import {toJson} from '@peachy/utility-kit-pure'
import {map, Observable} from 'rxjs'

export const mapToJson =
    <T>() =>
        (o: Observable<T>): Observable<string> =>
            o.pipe(map(toJson))
